/* eslint-disable no-nested-ternary */
import React from 'react';
import styled from 'styled-components';
import { _ } from '_locales';
import images from '_images';

/**
 * This component shows the levels which had passed or not passed yet on the top of games' page
 *
 */

const Levels = ({
  levels, currentLevelKey, modalVisible, windowsWidth, isOnBoarding
}) => {
  const numOfLevels = Object.keys(levels).length;

  const currentLevelValue = (currentLevelKey !== undefined) ? Number(currentLevelKey.split('_')[1].split('_')[0] - 1) : 0;

  const Container = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
`;

  const LevelsContainer = styled.div`
    padding: 10px 0px;
    margin-bottom: 50px;
    display: flex;
    justify-content: center;
    align-items: center;
    width: ${({ windowsWidth }) => (windowsWidth < 400 ? '98%' : ((windowsWidth < 750 ? `${(windowsWidth * (-1 / 10) + 130)}%` : '45%')))};
  `;

  const Circle = styled.div`
    border-radius: 50%;
    background-color: #efefef;
    color: black;
    display: flex;
    justify-content: center;
    align-items: center;
    width: ${({ windowsWidth }) => (windowsWidth >= 500 ? '30px' : '25px')};
    height: ${({ windowsWidth }) => (windowsWidth >= 500 ? '30px' : '25px')};
    font: ${({ windowsWidth }) => (windowsWidth >= 500 ? '18px' : '15px')} Arial, sans-serif;
    margin: 0 4px;
    box-shadow: ${((isOnBoarding) ? 'inset 0 0 0 1000px rgba(0,0,0,.3)' : 'none')};
    opacity: ${({ isOnBoarding }) => (isOnBoarding ? '0.4' : '1')};

    &.active {
      background-color: #2685d0;
      color: white;
    }

    &.finished {
      background-image: url(${images.recycleRight.level_completed});
      background-size: contain;
      background-position: center;
      text-indent: 100%;
      white-space: nowrap;
      overflow: hidden;
    }
  `;

  // const LevelsContainer = styled.div`
  //   display: flex;
  //   align-items: center;
  //   padding: 10px 10px;
  // `;

  const Line = styled.div`
    flex: 1;
    height: ${({ windowsWidth }) => (windowsWidth >= 500 ? '5px' : '3px')};
    background-color: #efefef;
    box-shadow: ${((isOnBoarding) ? 'inset 0 0 0 1000px rgba(0,0,0,.3)' : 'none')};
    &.passedLevels {
      background-color: #2685d0;
    }
    &.upCommingLevel {
      background-color: rgba(38, 133, 208, 0.5);
      }
    border-radius: 4px;
    opacity: ${({ isOnBoarding }) => (isOnBoarding ? '0.4' : '1')};
  `;

  const LevelsText = styled.p`
    font-size: ${({ windowsWidth }) => (windowsWidth >= 500 ? '18px' : '15px')};
    padding: 0px 10px;
    color: #6B6B6B;
  `;

  return (
    <Container>
      {/* <LevelsText
        windowsWidth={windowsWidth}
        isOnBoarding={isOnBoarding}
      >
        {_('recycleRight.level_upper_case')}

      </LevelsText> */}
      <LevelsContainer isOnBoarding={isOnBoarding} windowsWidth={windowsWidth}>
        {
          Object.keys(levels).map((level, i) => (
            <>
              {
                (currentLevelValue > i || (currentLevelValue === i && modalVisible))
                  ? (
                    <Circle
                      windowsWidth={windowsWidth}
                      isOnBoarding={isOnBoarding}
                      className={(currentLevelValue === i && !modalVisible && 'active') || ((currentLevelValue > i || (currentLevelValue === i && modalVisible)) && 'finished')}
                    />
                  ) : (
                    <Circle
                      windowsWidth={windowsWidth}
                      isOnBoarding={isOnBoarding}
                      className={(currentLevelValue === i && !modalVisible && 'active') || ((currentLevelValue > i || (currentLevelValue === i && modalVisible)) && 'finished')}
                    >
                      {i + 1}
                    </Circle>
                  )
              }
              {(i < numOfLevels - 1)
                && (
                  <Line
                    isOnBoarding={isOnBoarding}
                    windowsWidth={windowsWidth}
                    className={(currentLevelValue > i && 'passedLevels') || ((currentLevelValue === i && modalVisible) && 'upCommingLevel')}
                  />
                )}
            </>
          ))
        }
      </LevelsContainer>
    </Container>
  );
};

export default Levels;
